(() => {
  'use strict';
  const root = document.querySelector('[data-ms-fabric-library]');
  if (!root || root.dataset.filterMode === 'native') return;
  const groups = ['width','customisable'];
  const cards = () => [...root.querySelectorAll('[data-ms-library-card]')];
  const inputs = () => [...root.querySelectorAll('[data-ms-filter-input]')];
  const customInputs = () => inputs().filter((i)=>groups.includes(i.dataset.group));
  const selected = (group) => customInputs().filter((i)=>i.dataset.group===group && i.checked);
  const matchesGroup = (card,group,choices) => !choices.length || choices.some((i)=>String(card.dataset[group] || '')===String(i.value));
  const matchesCustom = (card, candidate = null) => groups.every((group) => {
    let choices = selected(group);
    if (candidate && candidate.dataset.group===group && !choices.includes(candidate)) choices=[...choices,candidate];
    return matchesGroup(card,group,choices);
  });

  const apply = () => {
    const base = cards().filter((card)=>!card.hidden);
    customInputs().forEach((input)=>{
      const count = base.filter((card)=>matchesCustom(card,input)).length;
      const target=input.closest('.ms-fl-filter-option')?.querySelector('[data-ms-option-count]');
      if(target) target.textContent=`(${count})`;
      input.disabled=count===0 && !input.checked;
    });
    base.forEach((card)=>{ if(!matchesCustom(card)) card.hidden=true; });
    const visible=cards().filter((card)=>!card.hidden).length;
    root.querySelectorAll('[data-ms-result-count]').forEach((node)=>node.textContent=`${visible} ${visible===1?'fabric':'fabrics'}`);
    const sheet=root.querySelector('[data-ms-sheet-count]'); if(sheet) sheet.textContent=String(visible);
    const empty=root.querySelector('[data-ms-empty]'); if(empty) empty.hidden=visible!==0;
  };

  const syncMoreCount = () => {
    const node=root.querySelector('[data-ms-secondary-count]');
    if(!node) return;
    const count=root.querySelectorAll('[data-ms-filter-more] [data-ms-filter-input]:checked').length;
    node.textContent=count?String(count):'';
  };
  const run = () => { apply(); syncMoreCount(); };
  const afterMain = () => setTimeout(run,0);
  const bind = () => {
    customInputs().forEach((input)=>input.addEventListener('change',afterMain));
    inputs().filter((input)=>!groups.includes(input.dataset.group)).forEach((input)=>input.addEventListener('change',afterMain));
    root.querySelector('[data-ms-library-sort]')?.addEventListener('change',afterMain);
    root.querySelectorAll('[data-ms-filter-reset],[data-ms-clear-all],[data-ms-library-search-clear],[data-ms-adjust-filters]').forEach((button)=>button.addEventListener('click',afterMain));
    root.querySelector('[data-ms-active-list]')?.addEventListener('click',afterMain);
    root.querySelector('[data-ms-library-search]')?.addEventListener('input',()=>setTimeout(run,150));
    run();
  };
  if(root.dataset.msFabricLibraryReady==='true') bind();
  else document.addEventListener('DOMContentLoaded',()=>setTimeout(bind,0),{once:true});
})();
